// tslint:disable: no-unused-expression
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { ColorConverterPipe } from 'src/app/pipes/color-converter.pipe';

import { THEMEVALUES } from "src/app/constants/themes";

import { ThemeStyle } from 'src/app/interfaces/theme';

@Injectable({ providedIn: 'root' })
export class GetCurrentThemeService {

  // themeValues: Guarda la configuración de los colores del tema seleccionado
  themeValues: ThemeStyle;
  // themeGroups: Guarda la configuración de los colores secundarios de cada tema
  themeGroups: string[];
  // emitter: Sujeto que comparte cambios en tiempo real
  emitter: Subject<true> = new Subject<true>();
  // tagStyle: Bandera para saber si las cabeceras se mostrará en gris o con el color del tema
  tagStyle: string;

  // ↓ Iniciacializa las popiedades de la clase para que nunca queden vacías
  constructor(private colorConverter: ColorConverterPipe) { this.setTheme("balanced"); }

  // setTheme() Método que modifica las propiedades de la clase según el tema seleccionado
  setTheme(selectedTheme?: string) {
    // ↓ Verifica si se cambió el tema para aplicar cambios y si simplemente se desea ejecutar actualización de vista en los componentes
    if (selectedTheme) {
      // ↓ Selecciona el tema de acuerdo a los parametros
      this.themeValues = THEMEVALUES[selectedTheme];
      // ↓ Reinicia los colores secundarios
      this.themeGroups = [];
      // ↓ Genera los colores secundarios del tema (7 colores)
      this.setThemeGroups(7);
    }
    // ↓ Comparte los cambios realizados
    this.emitter.next(true);
  }

  setThemeGroups(length: number) {
    for (let i = 0; i < length; i++) {
      // base: Obtiene los valores HSL del color principal del tema para poder cambiar los valores
      let base: (number | string)[] = this.colorConverter.transform(this.themeValues.background) as number[];
      // variant: Define la variación que tendrá la matiz del color
      const variant = this.themeValues.scale[0] / 2;
      // adjust: resultado del ajuste de la matiz de acuerdo a la matiz original, variacion y variación por nuevo color
      const adjust = (base[0] as number) - variant + (variant * i);
      // ↓ Aumenta/Disminuye la intensidad del coor de acuerdo al número definido por tema
      (base[2] as number) += (this.themeValues.scale[1]);
      // ↓ reduce/aumenta la matiz
      (base[0] as number) -= ((base[0] as number) - adjust);
      // ↓↓ Verifica que si el degradado es menor a 0 lo reinicie en 360
      (base[0] as number) < 0 ? base[0] = 360 - (base[0] as number) : null;
      (base[2] as number) < 0 ? base[2] = 360 - (base[2] as number) : null;
      // ↓↓ Verifica que si el degradado es mayor a 360 lo reinicie a su valor original
      (base[0] as number) > 360 ? base[0] = ((base[0] as number) - 360) : null;
      (base[2] as number) > 360 ? base[2] = ((base[2] as number) - 360) : null;
      // ↓ Redondea los resultados de la matiz e intensidad
      base = base.map((elm: number) => Math.round((elm as number)));
      // ↓ Obtiene el valor hexadecimal del resultado HSL
      base = this.colorConverter.transform(base as number[], "hslToHex");
      // ↓ Añade el color a la matriz
      this.themeGroups[i] = `#${base[0]}${base[1]}${base[2]}`;
    }
  }

}
